<template>
	<div class="form-group col-sm-6 mb-4 input-group-sm">
		<label class="mb-1 small" :for="name">{{ label }}</label>
		<select
			v-bind="$attrs"
			:value="modelValue"
			@change="$emit('update:modelValue', $event.target.value)"
			class="form-select"
			aria-label=".form-select-lg example small"
			:name="name"
		>
			<option
				v-for="(value, index) in selectData.values"
				:key="index"
				:value="value"
			>
				{{ selectData.valueLabels[index] }}
			</option>
		</select>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	export default {
		name: "BaseSelect",
		emits: ["update:modelValue"],
		props: {
			data: {
				type: [Object, Array],
				required: true,
			},
			dataKeys: {
				type: Array,
			},
			label: {
				type: String,
				required: true,
			},
			name: {
				type: String,
				required: true,
			},
			modelValue: {
				type: [String, null],
				required: true,
			},
		},

		setup: (props) => {
			let selectData = reactive({
				data: props.data,
				values: null,
				valueLabels: null,
			});

			const setData = async () => {
				if (!props.data[0] instanceof Object) {
					let values = props.data;
					selectData.values = values;
					selectData.valueLabels = values;
					return;
				}

				if (!props.data[0] instanceof Object) return;
				let keyOne = `item.${props.dataKeys[0]}`;
				let keyTwo = `item.${props.dataKeys[1]}`;
				let values = props.data.map((item) => eval(keyOne));
				let labels = props.data.map((item) => eval(keyTwo));

				selectData.values = values;
				selectData.valueLabels = labels;
			};
			setData();
			// watch(() => selectData, (selectData, prevSelectData) => setData(), {deep: true})

			return {
				selectData,
			};
		},
	};
</script>
